/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Subscriptions_TitleInputs */

const en_directory_submit_review_subscriptions_title = /** @type {(inputs: Directory_Submit_Review_Subscriptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing several products?`)
};

const zh_directory_submit_review_subscriptions_title = /** @type {(inputs: Directory_Submit_Review_Subscriptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`要上架多个产品？`)
};

/**
* | output |
* | --- |
* | "Listing several products?" |
*
* @param {Directory_Submit_Review_Subscriptions_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_subscriptions_title = /** @type {((inputs?: Directory_Submit_Review_Subscriptions_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Subscriptions_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_subscriptions_title(inputs)
	return zh_directory_submit_review_subscriptions_title(inputs)
});
export { directory_submit_review_subscriptions_title as "directory.submit.review.subscriptions_title" }